var render, staticRenderFns
import script from "./CalendarPane.vue?vue&type=script&lang=js&"
export * from "./CalendarPane.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPane.vue?vue&type=style&index=0&id=4a5f2beb&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f2beb",
  null
  
)

export default component.exports